import React from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

const DashboardPage = (props: any) => {
  return (
    <div>
      <Typography variant={'h4'}>Dashboard</Typography>
      <Paper sx={{ mt: 4 }}>
        <Box sx={{ p: 4 }}>
          <Typography>Ah. The dashboard of broken dreams ...</Typography>
        </Box>
      </Paper>
    </div>
  );
};

export default DashboardPage;
